module.exports = __webpack_public_path__ + "static/whatsapp-8ffbe0d64da8534b0ff767cd62121bff.svg";